import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { Flex } from '@cash-design-system/react'
import { CellDefaultCellDefaultAccessoryLeadingImage } from '@cash-web/protos/squareup/cash/ui/arcade/elements/CellDefault.pb'
import logger from '@cash-web/shared/util-logger'
import { replaceWithCDNImageUrl } from '@cash-web/shared-util-url'

const AccessoryLeadingImageContainer = styled.div`
  height: ${({ theme }) => theme.pxToRem(28)};
  width: ${({ theme }) => theme.pxToRem(28)};
`

const AccessoryLeadingImage = ({ image }: { image: CellDefaultCellDefaultAccessoryLeadingImage }) => {
  const { darkMode } = useTheme()
  const { t } = useTranslation()

  if (image?.icon) {
    logger.warn(new Error('ArcadeCellFromProto: Accessory leading image icon is not yet supported'))
    return null
  }

  if (image?.remote_image) {
    const lightUrl = image?.remote_image?.light_url
    const darkUrl = image?.remote_image?.dark_url ?? lightUrl

    const url = replaceWithCDNImageUrl({ url: darkMode ? darkUrl : lightUrl })

    return (
      <AccessoryLeadingImageContainer>
        <img
          width="100%"
          height="100%"
          src={url}
          alt={t('Accessory leading image', { context: 'image for accessory' })}
        />
      </AccessoryLeadingImageContainer>
    )
  }
  return null
}

export function ArcadeCellLabelAccessoryWrapper({
  accessoryLeadingImage,
  children,
}: React.PropsWithChildren<{
  accessoryLeadingImage?: CellDefaultCellDefaultAccessoryLeadingImage
}>) {
  return (
    <Flex gap="s" alignItems="center">
      {accessoryLeadingImage && <AccessoryLeadingImage image={accessoryLeadingImage} />}
      {children}
    </Flex>
  )
}
